export const BrowserEntryType = {
    DIR: 'dir',
    FILE: 'file',
    LINK: 'link',
};
